@if (offlineOrder()) {
  <mat-icon class="icon">description</mat-icon>
  <a lfwShouldOpenInNewTab [routerLink]="[offlineOrder().form.order.id]" class="doku">
    <div class="bigtext ordertext">{{ offlineOrder().form.order.text }}</div>
    <div class="states">
      <div class="text state small-text" [style]="getOrderStateStyle()">{{ getOrderStateText() }}</div>
      <div class="text state small-text" [style]="getSubStateStyle()">{{ getSubStateText() }}</div>
      <div class="text state small-text" [style]="getScenarioStyle()">{{ getScenarioText() }}</div>
    </div>
  </a>
  <div class="actions" [class.single-action]="isOffline()">
    <button mat-icon-button (click)="checkIn($event, offlineOrder().form.order.id)">
      <mat-icon>cloud_upload</mat-icon>
    </button>
    @if (!isOffline()) {
      <button mat-icon-button (click)="removeOffline($event, offlineOrder().form.order.id)">
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>
}
